import { useMutation, type UseMutationResult, useQueryClient } from "@tanstack/react-query";
import type { ApiError, ApiResponse } from "../../../types/apiResponse";
import { deleteChartAccount } from "../api/deleteChartAccount";
import withPrefix from "../../../helpers/useQueryPrefix";

export const useDeleteChartAccount = (): UseMutationResult<ApiResponse<null>, ApiError, number> => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: deleteChartAccount,
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: withPrefix(['chart_accounts']) });
		}
	})
}
